export default () => window._Flint.opts


/** WEBPACK FOOTER **
 ** ./client/lib/opts.js
 **/